<template>
  <div>
    <div
      v-for="(item, index) in items"
      :key="index"
      class="action-list-item mb-8"
    >
      <v-sheet
        class="action-list-item-card pa-4 rounded"
        data-testid="action-list-item"
      >
        <a
          class="font-size-18 text-blue-300"
          data-private
          data-testid="action-list-item-title"
          v-html="sanitizeContent(item.title)"
          :href="getEntityLink(item)"
        ></a>
        <p
          class="font-size-18 text-ui-700 mt-3 mb-0"
          data-private
          data-testid="action-list-item-text"
          v-html="sanitizeContent(item.text || '')"
        ></p>
        <div class="text-end">
          <ActionsButton
            data-testid="action-list-item-action"
            :data="item.action"
          />
        </div>
      </v-sheet>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import ActionsButton from '@/containers/ReportsView/Widgets/ActionsButton.vue'
import mixin from '@/mixins/mixin.vue'

export default {
  name: 'ActionList',

  components: {
    ActionsButton,
  },

  mixins: [mixin],

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  computed: {
    items() {
      return this.data?.items ?? []
    },
    organizationId() {
      return this.getOrganizationId()
    },
  },

  methods: {
    sanitizeContent(content) {
      return this.$sanitize(content)
    },

    getEntityLink(item) {
      const entityId = item?.entityId ?? ''
      let entityType = _.kebabCase(item?.entityType ?? '')
      // the following is needed given the tech debt
      // is needed to change this in api and urls
      if (entityType === 'improvement-idea') entityType = 'rev'
      return `/${entityType}/${this.organizationId}/${entityId}`
    },
  },
}
</script>

<style lang="scss" scoped>
.action-list {
  &-item {
    border: solid 1px $color-blue !important;
    border-radius: 4px;
  }

  &-item-card {
    background-color: $color-blue-grey-lighten3;
  }
}
</style>
